import React , { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import { ApiURLs, imageBaseUrls } from '../../constant/ApiUrls';
import Swal from 'sweetalert2';

import { NavigationRoutes } from '../../constant/Routes';
import { useLocation, useNavigate, useParams } from 'react-router-dom'; 
import dummyProfileImage from "../../components/assets/image/dummy-profile-image.png"
import moment from "moment";
import AddCategory from './components/AddCategory';
import { categoryLisitingRequest, deleteCategory } from './redux/categoryDispatcher';
// import placeholderImage from "../../components/assets/image/placeholder.png"; 
import placeholderImage from  "../../components/assets/image/placeholder.png";
function CategoriesListing({categoryListing}) {
  const { id } = useParams(); // Get the ID from the URL
  var parentId = 0;
  if(id){
    var m = id.replace(":", "");
    if(m){
      parentId = m;
    }
    
  }

  // console.log("categories listing-----",parentId);
  const paginationModel = { page: 0, pageSize: 10 };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const categoryListingHeading =[
    
    {
       field: "id", headerName: "NO", width: 40,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,

     },
     {
      field: "image",
      headerName: "Image",
      width: 100,
      sortable: false,

      renderCell: (params) => (
        <img
          src={params.value? `${imageBaseUrls}${params.value}`:placeholderImage}
          alt="Profile"
          style={{ width: 60, height: 60, borderRadius: "10px" }}
        />
      ),
    },
    {
      
      field: "name", headerName: "Category Name", width: 150 
    },
    {
      
      field: "description", headerName: "Description", width: 200 ,
      renderCell: (params) => (params.value=="" || params.value==null)?"No Description Added":params.value, 
    },
    //  { field: "created_at", headerName: "Created At", width: 170,
    //   renderCell: (params) => moment(params.value).format("DD/MM/YYYY HH:mm:ss"), 
    //   // renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,

    //  },
 

   
    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,

      renderCell: (params,row) => (
        <div style={{ display: "flex", flexDirection: "row", gap: "4px",alignItems: "center",
          height: "100%" }}>
               <button
          onClick={() => {
            console.log("veiw is called", params, row);
            // if(parentId==0){
              navigate(NavigationRoutes.ADMIN_DASHBOARD+NavigationRoutes.SUB_CATEGORIES.replace(":id",`:${params.row.id}`));
            // }

            
          }}
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100%",
            height: "24px",  // Increased height
            padding: "2px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {"Sub Categories"}
        </button>

        {params.row.id==62||params.row.parent_id==62?<div></div>: <button
          onClick={() => {
              navigate(NavigationRoutes.ADMIN_DASHBOARD+NavigationRoutes.ATTRIBUTES.replace(":id",`:${params.row.id}`));
          }}
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100%",
            height: "24px",  // Increased height
            padding: "2px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {"Attributes"}
        </button>}
       
        {/* <AddCategory parentId={params.row.id} buttonLabel="Add Sub Category"/> */}
        {/* <button
          onClick={() => {}}
          style={{
            backgroundColor: "#2196F3",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100%",
            height: "24px",  // Increased height
            padding: "2px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Add Sub Categories
        </button> */}
        <AddCategory
          parentId={parentId}
          buttonLabel="Edit"
          editMode={true}
          categoryData={params.row}
        />
     

        <button
          onClick={() => handleBlock(params.row)}
          style={{
            backgroundColor: "#F44336",
            color: "white",
            border: "none",
            cursor: "pointer",
            borderRadius: "4px",
            fontSize: "10px",
            width: "100%",
            height: "24px",  // Increased height
            padding: "2px 5px", // Added padding
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Delete
        </button>
      </div>
      
      ),
    },
  ];
  const handleBlock = (row) => {
    console.log("Deleting User ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete category "${row.name}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deleteCategory(row.id, parentId));
      }
    });
  
    // Add your delete logic here
  };

  React.useEffect(() => {
console.log("checking useeffect",parentId);
    dispatch(categoryLisitingRequest(parentId, true));
  }, [dispatch,parentId, location.pathname]);
  
  return (
    
    <Paper sx={{ height: "95%", width: '100%' }}>


{categoryListing.categoryDetail==null?<div style={{padding:"10px", justifyItems:"end"}}> 
<AddCategory parentId={parentId} buttonLabel={parentId==0?"Add Category":"Add Sub Category"}/>
  </div>
  : 


  <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "15px",
        backgroundColor: "#fff",
        border: "1px solid #ddd",
        borderRadius: "8px",
        // maxWidth: "600px",
        margin: "20px auto",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
      }}
    >
      {/* ✅ Category Image on the Left */}
      <img
        src={
          categoryListing?.categoryDetail?.image
            ? `${imageBaseUrls}${categoryListing.categoryDetail.image}`
            : placeholderImage
        }
        alt={categoryListing?.categoryDetail?.name || "Category"}
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "8px",
          objectFit: "cover",
          marginRight: "15px",
          border: "1px solid #ddd",
        }}
      />

      {/* ✅ Category Info (Name + Description) */}
      <div style={{ flexGrow: 1 }}>
        <h3
          style={{
            margin: "0",
            color: "#333",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          {categoryListing?.categoryDetail?.name || "Unnamed Category"}
        </h3>
        <p
          style={{
            marginTop: "5px",
            color: "#666",
            fontSize: "14px",
            lineHeight: "1.4",
          }}
        >
          {categoryListing?.categoryDetail?.description ||
            "No description available."}
        </p>
      </div>

      {/* ✅ Add Category / Sub-Category Button */}
      <div>
        <AddCategory
          parentId={parentId}
          buttonLabel={parentId == 0 ? "Add Category" : "Add Sub Category"}
        />
      </div>
    </div>


  // <div>

  //     lsdfkj lsfkjds flkjsf lksfj lskj fd

  //     <AddCategory parentId={parentId} buttonLabel={parentId==0?"Add Category":"Add Sub Category"}/>
  //   </div>
  
  }

   
         
      <DataGrid
        rows={categoryListing.categoryListing || []}
        columns={categoryListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading = {categoryListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
        

      />
    </Paper>
  );
}

//Getting the state from the store
const mapStateToProps = (state) => {
  return {
    categoryListing: state.categoryReducer, // Add optional chaining
  };
};
//passing the userData in fetchUsers function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    categoryLisitingRequest: () => dispatch({"type":"GET_CATEGORY_REQUEST"}), // Corrected function name
  };
};

//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(CategoriesListing);
